export const COMMON_RUNNING_TIMES_WIDGET_NAMESPACE = 'widget.common-running-times'
